import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {KNOWLEDGE_LIBRARY_FULL_PATH} from '../../Constants';

export const useChatBot = () => {
   const location = useLocation();

   useEffect(() => {
      if (window.Intercom) {
         if (location.pathname.includes(KNOWLEDGE_LIBRARY_FULL_PATH)) {
            window.Intercom('update', {
               hide_default_launcher: false,
            });
         } else {
            window.Intercom('hide');
            window.Intercom('update', {
               hide_default_launcher: true,
            });
         }
      }

      window.HubSpotConversations?.widget?.refresh();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [location.pathname]);
};
